import axios from '@/libs/api.request'

export const getTotalIncomeRank = data => {
  return axios.request({
    url: '/member/getTotalIncomeRank.json',
    method: 'post',
    data
  })
}

export const getFhlIncomeRank = data => {
    return axios.request({
      url: '/member/getFhlIncomeRank.json',
      method: 'post',
      data
    })
  }


// WEBPACK FOOTER //
// ./src/api/member.js